import { useEffect, useId, useRef } from "react";
import "./OpticksCheckbox.css";

interface Props {
  label?: React.ReactNode;
  id?: string | number | null;
  checked: boolean;
  indeterminate?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void | null;
  disabled?: boolean;
  children?: React.ReactNode;
}

const OpticksCheckbox = ({
  label,
  id,
  checked,
  indeterminate = false,
  onChange,
  disabled = false,
  children,
}: Props) => {
  const reactId = useId();
  const inputRef = useRef<HTMLInputElement>(null);
  const checkboxId = id != null ? String(id) : reactId;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <div className="opticks-checkbox">
      <input
        ref={inputRef}
        type="checkbox"
        id={checkboxId}
        name={checkboxId}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label && <label htmlFor={checkboxId}>{label}</label>}
      {children}
    </div>
  );
};

export default OpticksCheckbox;
